module.exports = {
  logger: function logger() {},
  progress: function progress() {}
};